/** @jsxRuntime automatic */
/** @jsxImportSource react */
import type { ReactNode } from 'react';
import { CircleAlert, CircleCheck, Info, TriangleAlert, type LucideIcon } from 'lucide-react';
import { Icon } from './Icon';

export type CalloutTone = 'info' | 'warn' | 'bad' | 'ok' | 'neutral';

const ICONS: Record<CalloutTone, LucideIcon> = { info: Info, warn: TriangleAlert, bad: CircleAlert, ok: CircleCheck, neutral: Info };

export interface CalloutProps {
  tone?: CalloutTone;
  title?: ReactNode;
  children?: ReactNode;
  /** A button on the right (Retry, Review). */
  action?: ReactNode;
  /** `alert` for something that just went wrong, `status` for a quiet update. */
  role?: 'alert' | 'status';
  icon?: LucideIcon;
}

/** A tinted note inside a page: info, warning, error or success, always with an icon and words, never colour alone. */
export function Callout({ tone = 'info', title, children, action, role, icon }: CalloutProps) {
  return (
    <div className={`ui-callout ui-callout--${tone}`} role={role}>
      <Icon icon={icon ?? ICONS[tone]} size="md" className="ui-callout-icon" />
      <div className="ui-callout-text">
        {title ? <p className="ui-callout-title">{title}</p> : null}
        {children ? <div className="ui-callout-body">{children}</div> : null}
      </div>
      {action ? <div className="ui-callout-action">{action}</div> : null}
    </div>
  );
}
